if (!customElements.get('product-stock-modal')) {
  customElements.define(
    'product-stock-modal',
    class ProductStockModal extends HTMLElement {
      constructor() {
        super();
      }
    },
  );
}
